export const brandInfo = {
  name: '策點文化 StratDot',
  tagline: '為讀者策選值得深入閱讀的內容',
  subTagline: '選書有方向，閱讀才有深度。',
  description: '策點文化以跨領域精選書籍為出版特色，內容涵蓋茶文化、商業、科普、醫療保健、心理學與人文社科。',
  fullDescription: '策點文化以跨領域選書為出版特色，內容涵蓋茶文化、商業、科普、醫療保健、心理學與人文社科等主題。透過不同領域的出版內容，提供讀者接觸知識、生活與社會議題的多元閱讀選擇。',
  parentBrand: '崧博出版事業有限公司',
  booksTWUrl: 'https://www.books.com.tw/web/sys_puballb/books/?pubid=knowledge12',
  parentUrl: 'https://sonbook.net/',
  catalogUrl: 'https://catalog.sonbook.net/',
};

export const brandIdentity = {
  fullCompanyName: '策點文化事業有限公司',
  brandName: '策點文化',
  englishName: 'STRATDOT',
  tagline: '跨領域選書，建立多元閱讀視角',
  intro: '策點文化以跨領域選書為出版特色，內容涵蓋茶文化、商業、科普、醫療保健、心理學與人文社科等主題。透過不同領域的出版內容，提供讀者接觸知識、生活與社會議題的多元閱讀選擇。網站呈現策點文化的品牌定位、2026 最新發行書籍與相關出版資訊。',
  relationship: '本品牌委託崧博出版經銷，官方網站由崧博出版製作。',
  catalogNote: '完整書名、作者、ISBN、內容主題、出版品牌及相關出版資訊，以崧博書籍資料庫中的個別書籍頁為準。',
  catalogUrl: 'https://catalog.sonbook.net/',
};

export const brandPublishingAreas = [
  {
    id: 'area-tea',
    title: '茶文化',
    icon: 'ri-cup-line',
    description: '出版與茶葉知識、飲茶文化、歷史及生活相關的閱讀內容。',
  },
  {
    id: 'area-business',
    title: '商業',
    icon: 'ri-line-chart-line',
    description: '出版與商業思考、管理、職場及經營議題相關的閱讀內容。',
  },
  {
    id: 'area-science',
    title: '科普',
    icon: 'ri-microscope-line',
    description: '出版與自然、科學及生活知識相關的閱讀內容。',
  },
  {
    id: 'area-health',
    title: '醫療保健',
    icon: 'ri-heart-pulse-line',
    description: '出版與健康、醫療及保健知識相關的閱讀內容。',
  },
  {
    id: 'area-psych',
    title: '心理學',
    icon: 'ri-brain-line',
    description: '出版與自我理解、情緒、人際互動及大眾心理學相關的閱讀內容。',
  },
  {
    id: 'area-humanities',
    title: '人文社科',
    icon: 'ri-book-open-line',
    description: '出版與歷史、文化、社會、思想及公共議題相關的閱讀內容。',
  },
];

export const navItems = [
  { label: '首頁', href: '/' },
  { label: '品牌介紹', href: '/about' },
  { label: '書籍資料庫', href: 'https://catalog.sonbook.net/', external: true },
  { label: '合作通路', href: '/stores' },
  { label: '常見問題', href: '/faq' },
  { label: '編輯選書', href: '/blog' },
];

export const brandPhilosophy = [
  {
    id: 'phil-1',
    title: '選書，是一種閱讀服務',
    description: '透過清楚的選書標準，協助讀者降低尋找與判斷內容的成本，找到符合閱讀需求的出版品。',
    icon: 'ri-bookmark-line',
  },
  {
    id: 'phil-2',
    title: '跨領域，不代表沒有方向',
    description: '策點文化涵蓋不同知識領域，但各出版方向皆以主題清楚、內容價值與實用意義作為整理基礎。',
    icon: 'ri-compass-3-line',
  },
  {
    id: 'phil-3',
    title: '不只分類，也要策展',
    description: '除了依主題分類，策點文化也從內容特色、閱讀價值與知識脈絡重新整理書籍之間的關係。',
    icon: 'ri-layout-masonry-line',
  },
  {
    id: 'phil-4',
    title: '讓好內容被看見',
    description: '策點文化關注能提供清楚觀點、實用方法或長期知識價值的出版內容，並協助讀者找到合適的閱讀入口。',
    icon: 'ri-lightbulb-line',
  },
];

export const publishingDirections = [
  {
    id: 'dir-tea',
    title: '茶文化',
    description: '出版與茶葉知識、飲茶文化、歷史及生活相關的閱讀內容。',
    imageSeq: 'dir-tea-x4',
  },
  {
    id: 'dir-business',
    title: '商業',
    description: '出版與商業思考、管理、職場及經營議題相關的閱讀內容。',
    imageSeq: 'dir-business-x4',
  },
  {
    id: 'dir-science',
    title: '科普',
    description: '出版與自然、科學及生活知識相關的閱讀內容。',
    imageSeq: 'dir-science-x4',
  },
  {
    id: 'dir-health',
    title: '醫療保健',
    description: '出版與健康、醫療及保健知識相關的閱讀內容。',
    imageSeq: 'dir-health-x4',
  },
  {
    id: 'dir-psych',
    title: '心理學',
    description: '出版與自我理解、情緒、人際互動及大眾心理學相關的閱讀內容。',
    imageSeq: 'dir-psych-x4',
  },
  {
    id: 'dir-humanities',
    title: '人文社科',
    description: '出版與歷史、文化、社會、思想及公共議題相關的閱讀內容。',
    imageSeq: 'dir-humanities-x4',
  },
];

export const homeFAQ = [
  {
    q: '策點文化是什麼品牌？',
    a: '策點文化以跨領域精選書籍為出版特色，涵蓋茶文化、商業、科普、醫療保健、心理學與人文社科六大出版方向。',
  },
  {
    q: '策點文化出版哪些類型的書？',
    a: '策點文化目前涵蓋茶文化、商業、科普、醫療保健、心理學與人文社科六個出版方向。',
  },
  {
    q: '策點文化適合哪些讀者？',
    a: '適合喜歡跨領域閱讀、重視知識密度與內容價值，並希望從書籍中拓展生活、工作和自我理解的讀者。',
  },
  {
    q: '策點文化和崧博出版是什麼關係？',
    a: '本品牌委託崧博出版經銷，官方網站由崧博出版製作。策點文化具有自身出版定位，不是崧博旗下品牌或子品牌。',
  },
  {
    q: '策點文化的書在哪裡可以購買？',
    a: '策點文化出版書籍可透過博客來、誠品、金石堂、三民、momo、蝦皮、taaze讀冊等線上通路查找紙本書，電子書可於樂天kobo、pubu、mybook等平台選購。不同作品在各平台的上架狀態、版本、價格及庫存可能不同，實際資訊請以各通路頁面為準。',
  },
  {
    q: '如何查詢完整書目？',
    a: '完整書名、作者、內容主題及相關出版資訊，請前往崧博書籍資料庫查詢。',
  },
];

import { latestBrandReleases } from '../../../shared/brand-latest/latestReleases';

export const latest2026Books = [
  ...latestBrandReleases
    .filter((book) => book.brandSlug === 'cedian-culture')
    .map((book) => ({
      id: book.id,
      isbn: book.isbn,
      title: book.title,
      subtitle: book.subtitle,
      author: book.author,
      authorRole: '',
      series: '',
      category: book.category,
      publishDate: book.publishDate,
      coverUrl: book.coverImage,
      description: book.summary,
    })),
  {
    id: '2026-01',
    isbn: '9786269312832',
    title: '從來沒有天賦優越',
    subtitle: '18位知名科學家的學習思維',
    author: '姚建明',
    authorRole: '編著',
    series: '智識界10',
    category: '科普書',
    coverUrl: 'https://storage.readdy-site.link/project_files/1f915489-d2bb-41ea-8578-6e8214ecd4ed/87cec6b0-4941-424d-82df-b856f24b4d4e_compressed_9786269312832.webp',
    description: '天才不是天生，而是一步步被「設計」出來的思考方式。從愛因斯坦到費曼，看見真正拉開差距的學習關鍵。',
  },
  {
    id: '2026-02',
    isbn: '9786269312849',
    title: '綠茶，懂喝從這一杯開始',
    subtitle: '以生活化的角度，讀懂綠茶的知識與趣味',
    author: '王岳飛、周繼紅',
    authorRole: '主編',
    series: '食茶所04',
    category: '茶書',
    coverUrl: 'https://storage.readdy-site.link/project_files/1f915489-d2bb-41ea-8578-6e8214ecd4ed/d1db2dd6-445c-48c6-91a0-c08714888be5_compressed_9786269312849.webp',
    description: '從茶樹、茶藝到茶道精神，展開綠茶世界的深厚樣貌。喝下的不只是清香，更是千年茶史與山水風土。',
  },
  {
    id: '2026-03',
    isbn: '9786269312801',
    title: '波動有規律，散戶也能看懂的艾略特理論操盤法',
    subtitle: '看懂集體行為規律，預測每次市場大循環',
    author: '[美]拉爾夫·尼爾森·艾略特',
    authorRole: '著，諸葛金融 編譯',
    series: '商學派09',
    category: '商業書',
    coverUrl: 'https://storage.readdy-site.link/project_files/1f915489-d2bb-41ea-8578-6e8214ecd4ed/e26ec3b2-17c8-4a8a-81e9-c07d53c97bbe_compressed_9786269312801.webp',
    description: '單一指標老是失真？掌握市場規律才能建立雙重保險。褪去無效指標，你的投資書架就差這最後一本。',
  },
  {
    id: '2026-04',
    isbn: '9786269312818',
    title: '電子科學簡史，從雨天風箏到半導體的故事',
    subtitle: '點亮數位文明的奈米閃光',
    author: '張天蓉',
    authorRole: '著',
    series: '智識界08',
    category: '科普書',
    coverUrl: 'https://storage.readdy-site.link/project_files/1f915489-d2bb-41ea-8578-6e8214ecd4ed/8915f4f3-2ebe-48b6-a733-e3121d48a562_compressed_9786269312818.webp',
    description: '從雨天風箏到半導體，法拉第、特斯拉、愛迪生的發現與發明如何改變世界。在背公式之前，先看幾個故事。',
  },
  {
    id: '2026-05',
    isbn: '9786269312825',
    title: '贏在轉折前，散戶也能看懂的江恩理論操盤法',
    subtitle: '看懂角度線與成交量密碼，你也能在趨勢反轉前冷靜布局',
    author: '[美]威廉·江恩',
    authorRole: '著，諸葛金融 編譯',
    series: '商學派08',
    category: '商業書',
    coverUrl: 'https://storage.readdy-site.link/project_files/1f915489-d2bb-41ea-8578-6e8214ecd4ed/32770e11-105d-4ba3-a91f-e44fab5f9c3b_compressed_9786269312825.webp',
    description: '老是買在山頂、賣在低谷？快告別隨機盲目，建立進階交易邏輯。在趨勢反轉前冷靜布局。',
  },
  {
    id: '2026-06',
    isbn: '9786269304677',
    title: '烏龍茶，原來如此',
    subtitle: '從大紅袍到東方美人，快速掌握烏龍茶的風味世界',
    author: '李遠華',
    authorRole: '著',
    series: '食茶所03',
    category: '茶書',
    coverUrl: 'https://storage.readdy-site.link/project_files/1f915489-d2bb-41ea-8578-6e8214ecd4ed/d57af0c6-e1af-4b3f-b6ae-3f3a2d6dd8a9_compressed_9786269304677.webp',
    description: '一杯烏龍茶，藏著山海風土與時間雕琢的層層風味。從產地到茶席，讀懂香氣背後的技藝與傳承。',
  },
  {
    id: '2026-07',
    isbn: '9786269304691',
    title: '順勢就賺錢，散戶也能看懂的道氏理論操盤法',
    subtitle: '看懂多空節奏，精準掌握每一次進出場時機',
    author: '[美]羅伯特·雷亞',
    authorRole: '著，諸葛金融 編譯',
    series: '商學派07',
    category: '商業書',
    coverUrl: 'https://storage.readdy-site.link/project_files/1f915489-d2bb-41ea-8578-6e8214ecd4ed/3d97ad2f-c740-4633-bb67-f5fb224e51d0_compressed_9786269304691.webp',
    description: '市場沒有秘密，只有尚未被理解的規律。學會等待，比學會進場更重要。經典理論，重新校準你的投資思維。',
  },
  {
    id: '2026-08',
    isbn: '9786269304684',
    title: '被忽略的宇宙主體，暗物質觀測與實驗',
    subtitle: '旋轉曲線、引力透鏡、星系碰撞，探索「不可見」物質的存在依據',
    author: '李金',
    authorRole: '著',
    series: '智識界07',
    category: '科普書',
    coverUrl: 'https://storage.readdy-site.link/project_files/1f915489-d2bb-41ea-8578-6e8214ecd4ed/8f31a54d-0012-445f-a701-d5b862ba5e7e_compressed_9786269304684.webp',
    description: '你以為宇宙由可見物質構成，其實大部分質量無法被觀測。那些看不見的存在，正透過引力悄悄塑造整個宇宙。',
  },
  {
    id: '2026-09',
    isbn: '9786269304646',
    title: '白茶入盞',
    subtitle: '風土氣息×製茶工序×沖泡層次，清湯之中展開層層遞進的風味脈絡',
    author: '秦夢華',
    authorRole: '著',
    series: '食茶所02',
    category: '茶書',
    coverUrl: 'https://storage.readdy-site.link/project_files/1f915489-d2bb-41ea-8578-6e8214ecd4ed/05006fa9-bcc4-4b49-8075-dafea4dbd3c3_compressed_9786269304646.webp',
    description: '初入口時清淡，回味卻悠長如遠山。白茶的韻味，在時間裡緩緩沉澱，從清湯之中展開層層遞進的風味脈絡。',
  },
];

const latestBookImageSequences = [
  'book-tea-space-x1',
  'book-decision-x1',
  'book-micro-x1',
  'book-emotion-x1',
] as const;

export const latestBooks = latest2026Books.map((book, index) => ({
  id: book.id,
  imageSeq: latestBookImageSequences[index % latestBookImageSequences.length],
  tag: book.category,
  title: book.title,
  author: book.author,
  publishDate: 'publishDate' in book ? book.publishDate : '',
  summary: book.description,
}));

export const columnCategories = brandPublishingAreas.map((area) => ({
  id: area.id.replace('area-', 'col-'),
  title: area.title,
  description: area.description,
}));

export const readingGuides = publishingDirections.map((direction) => {
  const topicId = direction.id.replace('dir-', '');
  return {
    id: `guide-${topicId}`,
    topicId,
    imageSeq: `guide-${topicId}-x1`,
    title: direction.title,
    description: direction.description,
  };
});

export const topics = brandPublishingAreas.map((area) => ({
  id: area.id.replace('area-', ''),
  title: area.title,
  description: area.description,
  tags: [area.title],
}));

export const footerLinks = [
  { label: '品牌介紹', href: '/about' },
  { label: '合作通路', href: '/stores' },
  { label: '常見問題', href: '/faq' },
  { label: '閱讀推薦', href: '/blog' },
  { label: '崧博出版主站', href: 'https://sonbook.net/' },
  { label: '崧博書籍資料庫', href: 'https://catalog.sonbook.net/' },
];
